import { useState, useEffect, use } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { getCart, getUser, getCartTotal, clearCart } from "../../utils/cart";
import {
  addToCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
} from "../../utils/cart";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
  apiTest_Url,staticToken
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";
import { TailSpin } from "react-loader-spinner";
interface Address {
  id: number;
  type: string;
  name: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  isDefault: boolean;
}

export default function CheckoutPage() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    SODBody,
    setSODBody,
  } = context;

  const cartItems = getCart();
  const subtotal = getCartTotal();
  const shipping = subtotal > 1000 ? 0 : 50;
  const total = subtotal + shipping;

  const [loading, setLoading] = useState(true);
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});

  const [Categories, setCategories] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [ItemMasterData, setItemMasterData] = useState<any[]>([]);

  const [step, setStep] = useState(1);
  const [savedAddresses, setSavedAddresses] = useState<Address[]>([
    {
      id: 1,
      type: "Home",
      name: "Rahul Sharma",
      phone: "+91 98765 43210",
      email: "rahul.sharma@email.com",
      address: "123 Green Valley Road, Andheri West",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400058",
      isDefault: true,
    },
    {
      id: 2,
      type: "Office",
      name: "Rahul Sharma",
      phone: "+91 98765 43210",
      email: "rahul.sharma@email.com",
      address: "Tower B, 5th Floor, Tech Park, Powai",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400076",
      isDefault: false,
    },
  ]);

  const [AddressData, setAddressesData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [addressNickName, setAddressNickName] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [cityID, setCityID] = useState("");
  const [state, setState] = useState("");
  const [stateID, setStateID] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [country, setCountry] = useState("");
  const [addressType, setAddressType] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [userMobile, setUserMobile] = useState("");

  const [showAddressForm, setShowAddressForm] = useState(false);
  const [newAddressForm, setNewAddressForm] = useState({
    type: "Home",
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });
  const [sameAsBilling, setSameAsBilling] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("card");

  // const selectedAddress = savedAddresses.find(
  //   (a) => a.id === selectedAddressId,
  // );

  const handleNewAddressChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    setNewAddressForm({
      ...newAddressForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveNewAddress = () => {
    if (
      !newAddressForm.name ||
      !newAddressForm.phone ||
      !newAddressForm.address ||
      !newAddressForm.city ||
      !newAddressForm.state ||
      !newAddressForm.pincode ||
      !newAddressForm.email
    ) {
      return;
    }

    const newAddress: Address = {
      id: Date.now(),
      type: newAddressForm.type,
      name: newAddressForm.name,
      phone: newAddressForm.phone,
      email: newAddressForm.email,
      address: newAddressForm.address,
      city: newAddressForm.city,
      state: newAddressForm.state,
      pincode: newAddressForm.pincode,
      isDefault: savedAddresses.length === 0,
    };

    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress.id);
    setShowAddressForm(false);
    setNewAddressForm({
      type: "Home",
      name: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
    });
  };

  const handlePlaceOrder = () => {
    const orderId = `ORD-${Date.now()}`;
    clearCart();
    navigate(`/payment-confirmation?orderId=${orderId}&amount=${total}`);
  };

  const getAddressIcon = (type: string) => {
    switch (type) {
      case "Home":
        return "ri-home-4-line";
      case "Office":
        return "ri-building-line";
      default:
        return "ri-map-pin-line";
    }
  };

  useEffect(() => {
    getItems();
    getAddress();
    window.scrollTo(0, 0);
  }, []);

  const getAddress = () => {
    const userData: any = getUser();
    if (contactMobile === "" && contactName === "") {
      setContactMobile(userData?.SignInMobile);
      setContactName(userData?.LedgerName);
    }

    getRecords(
      3406,
      100,
      -1,
      `{DistributorID: { $in: [${userData?.LedgerID}] }}`,
      1,
      "",
      (data: any) => {
        // console.log("user details response", response);

        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records.length > 0) {
            setAddressesData(data?.response?.records || []);

            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
    );
  };

  const getdataformItemMaster = (ids: any) => {
    getRecords(1478, 100, -1, `{ItemID: { $in: [${ids}] }}`, 1, "", (data) => {
      // console.log("user details response", response);

      if (data != null) {
        if (data?.hasErrors === false) {
          setItemMasterData(data?.response?.records || []);

          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching categories", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const getItems = () => {
    const cart = localStorage.getItem("cart-UniversalDairy");
    let ids = null;

    if (cart) {
      const parsedCart = JSON.parse(cart);
      const qtyMap: { [key: number]: number } = {};

      parsedCart.forEach((item: any) => {
        qtyMap[item.ItemID] = item.Qty;
      });

      setQuantities(qtyMap);

      const itemIdsInCart = parsedCart.map((item: any) => item.ItemID);
      ids = itemIdsInCart.join(",");
    }

    const PriceID = localStorage.getItem("UserData-UniversalDairy")
      ? JSON.parse(localStorage.getItem("UserData-UniversalDairy") || "{}")
          .ContractID
      : 1;
    let Url = `${BaseUrl}/api/Dynamic/GetRecords?tabErpID=${3323}&tabName=Sub%20Category`;

    const itemBody = {
      pgSize: 1000,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "admin@dialerp.com",
      tabErpID: 3323,
      useAtlusSearch: false,
      RoleID: 0,
      LedgerID: LoggedInUserID ? LoggedInUserID : 1002, // replace with your actual variable
      order: -1,
      orderBy: "",
      processID: 1,

      filters: `{ItemID: { $in: [${ids}] },'PriceContractID':${PriceID || 1},'ValidFrom': { $lte: ISODate('${new Date().toISOString()}')}}`,
    };

    callApi(
      Url,
      itemBody,
       Authorization_Token ? Authorization_Token : staticToken,
      (data: any) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setItems(data?.response?.records || []);

            if (data?.response?.records?.length > 0) {
              getdataformItemMaster(
                data?.response?.records
                  ?.map((item: any) => item.ItemID)
                  .join(",") ?? "",
              );
            }

            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
      (error: any) => {
        setLoading(false);
      },
    );
  };
 const calculateSubtotal = () => {
  const cart = getCart();
  let subtotal = 0;

  cart.forEach((cartItem: any) => {
    const priceItem = items?.find(
      (p) => p.ItemID === cartItem.ItemID
    );

    const item = ItemMasterData?.find(
      (i) => i.ItemID === cartItem.ItemID
    );

    const caseRate = parseFloat(
      priceItem?.DistributorCaseRate || "0"
    );
    const units = parseFloat(
      priceItem?.ItemInCase || "0"
    );

    let unitPrice = 0;

    if (caseRate > 0 && units > 0) {
      unitPrice = caseRate / units;
    } else {
      unitPrice = parseFloat(item?.MRP || "0");
    }

    subtotal += unitPrice * cartItem.Qty;
  });

  return subtotal;
};
  const getItemQty = (itemId: number) => {
    const cart = getCart();

    if (cart) {
      const item = cart?.find((i: any) => i.ItemID === itemId);

      return item ? item.Qty : 0;
    } else {
      return 1;
    }
  };

  const handlePayNow = () => {
    let UserData: any = getUser();

    let payBody = {
      BillFromLedgerID: UserData?.SellerID,
      BillToLedgerID: UserData?.LedgerID,
      Currency: "INR",
      DiscountAmt: 0,
      ExtraRemarks: "",
      IsMembership: false,
      ItemRateVersion: 2,
      NetAmt: calculateSubtotal(),
      ShipTo: {
        Type: 1,
        BillSr: selectedAddress?.SiteID,
        LedgerID: selectedAddress?.SiteID,
        LedgerName: UserData?.LedgerName,
        AliasName: sameAsBilling
          ? UserData?.LedgerName
          : selectedAddress?.LedgerName,
        AliasID: 0,
        NetAmt: 0,
        DiscountAmt: 0,
        TaxAmt: 0,
        TotalAmt: 0,
        Narration: "",
        AliasCode: "",
        LedgerGroup: userData?.LedgerGroup,
        LedgerGroupID: userData?.LedgerGroupID,
        StateCode: selectedAddress?.StateCode,
        Landmark: "",
        City: selectedAddress?.City,
        State: selectedAddress?.State,
        StateID: selectedAddress?.StateID,
        CityID: selectedAddress?.CityID,
        Country: selectedAddress?.Country,
        AddressLine1: sameAsBilling
          ? selectedAddress?.Address
          : selectedAddress?.Address,
        AddressLine2: "",

        Pincode: selectedAddress?.Pincode,

        UserID: userData?.LedgerID,
        UserMobile: sameAsBilling
          ? userData?.SignInMobile
          : selectedAddress?.SignInMobile,
      },

      ObjItems: items?.map((item: any) => ({
        AltUnit1: "",
        AltUnit2: "",
        AltUnit3: "",
        AutofillTxt: `${item.Item}(${item.ItemID})`,
        BaseUnit: item.BaseUnit,
        BaseUnitID: item.BaseUnitID || 0,
        BillAmount: item.NetRate,
        CGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.CGST || 0,
        Conversion:
          ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Conversion ||
          0,
        DisAmt: 0,
        DisPer: 0,
        IGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.IGST || 0,
        IgstAmt: 0,
        Item: item.Item,
        ItemID: item.ItemID,
        ItemPic: item.ItemPic,
        MRP: getDisplayPrice(item.ItemID),
        MSP: getDisplayPrice(item.ItemID),
        NetAmt: getDisplayPrice(item.ItemID),
        NetRate: getDisplayPrice(item.ItemID),
        ObjTaxLst: [],
        Qty: getItemQty(item.ItemID),
        SGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.SGST || 0,
        SaleUnit: item.SaleUnitInPck,
        SaleUnitID: item.SaleUnitID || 0,
        Size: item?.Size || 0,
        StrDeliveryDate: new Date().toISOString().split("T")[0],
        TcsAmt: 0,
        TcsPer: 0,
        TtCessAmt: 0,
        TtExtraCessAmt: 0,
        TtTaxAmt: 0,
        TtTaxPer: item.TtTaxPer,
        Uom: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Uom || 0,
      })),
      // ObjOtherCharges: [
      //   {
      //     ChargeOnType: "1",
      //     ChargesType: "1",
      //     HsnSac: "060310",
      //     LedgerID: UserData?.LedgerID,
      //     SalePrice: "0.00",
      //     TaxPer: "0.00",
      //   },
      //   {
      //     ChargeOnType: "1",
      //     ChargesType: "1",
      //     HsnSac: "",
      //     LedgerID: UserData?.LedgerID,
      //     SalePrice: "0.00",
      //     TaxPer: "0.00",
      //   },
      // ],
      OrderType: 0,
      PayableAmt: calculateSubtotal(),
      RoundOffAmt: calculateSubtotal(),
      SaleTeamID: 0,
      SoID: 0,
      SoName: "",
      SubVchType: 4,
      TaxAmt: 0,
      TaxInclusion: 1,
      TaxType: 2,
      TcsAmt: 0,
      TcsPer: 0,
      TdsAmt: 0,
      TdsPercent: 0,
      TotalAmt: calculateSubtotal(),
      TotalQty: items?.length,
      TtCessAmt: 0,
      TtExtraCessAmt: 0,
      UserID: UserData?.LedgerID,
      VchDate: new Date().toISOString().split("T")[0],
      VchStatus: 1,
      VchType: 3,
      ordersL1: 1,
      toEmailID: "",
    };

    let invoiceBody = {
      OrderAgainstID: UserData?.LedgerID,
      TransactionID: 25648,
      OrderAgainst: 25648,
      TaxInclusion: 0,
      VchDate: "2026-02-13 15:30:00",
      SoName: "",
      Currency: "INR",
      VchType: 4,
      Remarks: "Payment received",
      NetAmt: 1.0,
      PayableAmt: 0.0,
      DiscountAmt: 0.0,
      TaxAmt: 0.0,
      TaxType: 1,
      TotalAmt: 1.0,
      RoundOffAmt: 0.0,
      TdsPercent: 0.0,
      TcsAmt: 0.0,
      TcsPer: 0.0,
      TdsAmt: 0.0,
      TtCessAmt: 0.0,
      TtExtraCessAmt: 0.0,
      TotalQty: 0,
      UserID: userData?.LedgerID,
      toEmailID: userData?.SignInEmail,
      BillFrom: {
        LedgerID: userData?.SellerID,
        LedgerName: userData?.Seller,
      },
      BillTo: {
        LedgerID: userData?.LedgerID,
        LedgerName: userData?.LedgerName,
      },
      ObjParticulars: [
        {
          LedgerID: userData?.LedgerID,
          Amount: 1.0,
        },
      ],

      ObjItems: items?.map((item: any) => ({
        AltUnit1: "",
        AltUnit2: "",
        AltUnit3: "",
        AutofillTxt: `${item.Item}(${item.ItemID})`,
        BaseUnit: item.BaseUnit,
        BaseUnitID: item.BaseUnitID || 0,
        BillAmount: item.NetRate,
        CGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.CGST || 0,
        Conversion:
          ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Conversion ||
          0,
        DisAmt: 0,
        DisPer: 0,
        IGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.IGST || 0,
        IgstAmt: 0,
        Item: item.Item,
        ItemID: item.ItemID,
        ItemPic: item.ItemPic,
        MRP: getDisplayPrice(item.ItemID),
        MSP: getDisplayPrice(item.ItemID),
        NetAmt: getDisplayPrice(item.ItemID),
        NetRate: getDisplayPrice(item.ItemID),
        ObjTaxLst: [],
        Qty: getItemQty(item.ItemID),
        SGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.SGST || 0,
        SaleUnit: item.SaleUnitInPck,
        SaleUnitID: item.SaleUnitID || 0,
        Size: item?.Size || 0,
        StrDeliveryDate: new Date().toISOString().split("T")[0],
        TcsAmt: 0,
        TcsPer: 0,
        TtCessAmt: 0,
        TtExtraCessAmt: 0,
        TtTaxAmt: 0,
        TtTaxPer: item.TtTaxPer,
        Uom: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Uom || 0,
      })),
    };

    let url3 = `${apiTest_Url}/api/finance/generateSOD`;

    console.log("Pay Body", payBody);
    callApi(
      url3,
      payBody,
      Authorization_Token,
      (response: any) => {
        if (response != null) {
          if (response?.hasErrors === false) {
            alert(response?.response?.msg);
          } else {
            alert(response?.errors);
          }
        }
      },
      (error: any) => {},
    );
  };

  const handlePayment = () => {
    setLoading(true);
    let UserData: any = getUser();
    const body = {
      Amount: Math.round(calculateSubtotal()),
      //  Math.round(calculateSubtotal()),
      Phone: UserData?.SignInMobile?.toString(),
      Email: UserData?.SignInEmail?.toString(),
      FirstName: UserData?.LedgerName?.toString(),
      SubscriberID: subID,
      SubDomain: "universal",
      BillToLedgerID: UserData?.LedgerID?.toString(),
      isSplitAmount: true,
      orderID: UserData?.SellerID,
    };

    let payBody = {
      BillFromLedgerID: UserData?.SellerID,
      BillToLedgerID: UserData?.LedgerID,
      Currency: "INR",
      DiscountAmt: 0,
      ExtraRemarks: "",
      IsMembership: false,
      ItemRateVersion: 2,
      NetAmt: calculateSubtotal(),
      ShipTo: {
        Type: 1,
        BillSr: selectedAddress?.SiteID,
        LedgerID: selectedAddress?.SiteID,
        LedgerName: UserData?.LedgerName,
        AliasName: sameAsBilling
          ? UserData?.LedgerName
          : selectedAddress?.LedgerName,
        AliasID: 0,
        NetAmt: 0,
        DiscountAmt: 0,
        TaxAmt: 0,
        TotalAmt: 0,
        Narration: "",
        AliasCode: "",
        LedgerGroup: userData?.LedgerGroup,
        LedgerGroupID: userData?.LedgerGroupID,
        StateCode: selectedAddress?.StateCode,
        Landmark: "",
        City: selectedAddress?.City,
        State: selectedAddress?.State,
        StateID: selectedAddress?.StateID,
        CityID: selectedAddress?.CityID,
        Country: selectedAddress?.Country,
        AddressLine1: sameAsBilling
          ? selectedAddress?.Address
          : selectedAddress?.Address,
        AddressLine2: "",

        Pincode: selectedAddress?.Pincode,

        UserID: userData?.LedgerID,
        UserMobile: sameAsBilling
          ? userData?.SignInMobile
          : selectedAddress?.Phone,
      },
      ObjItems: items?.map((item: any) => ({
        AltUnit1: "",
        AltUnit2: "",
        AltUnit3: "",
        AutofillTxt: `${item.Item}(${item.ItemID})`,
        BaseUnit: item.BaseUnit,
        BaseUnitID: item.BaseUnitID || 0,
        BillAmount: item.NetRate,
        CGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.CGST || 0,
        Conversion:
          ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Conversion ||
          0,
        DisAmt: 0,
        DisPer: 0,
        IGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.IGST || 0,
        IgstAmt: 0,
        Item: item.Item,
        ItemID: item.ItemID,
        ItemPic: item.ItemPic,
        MRP: getDisplayPrice(item.ItemID),
        MSP: getDisplayPrice(item.ItemID),
        NetAmt: getDisplayPrice(item.ItemID),
        NetRate: getDisplayPrice(item.ItemID),
        ObjTaxLst: [],
        Qty: getItemQty(item.ItemID),
        SGST: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.SGST || 0,
        SaleUnit: item.SaleUnitInPck,
        SaleUnitID: item.SaleUnitID || 0,
        Size: item?.Size || 0,
        StrDeliveryDate: new Date().toISOString().split("T")[0],
        TcsAmt: 0,
        TcsPer: 0,
        TtCessAmt: 0,
        TtExtraCessAmt: 0,
        TtTaxAmt: 0,
        TtTaxPer: item.TtTaxPer,
        Uom: ItemMasterData?.find((i) => i.ItemID === item.ItemID)?.Uom || 0,
      })),
      // ObjOtherCharges: [
      //   {
      //     ChargeOnType: "1",
      //     ChargesType: "1",
      //     HsnSac: "060310",
      //     LedgerID: UserData?.LedgerID,
      //     SalePrice: "0.00",
      //     TaxPer: "0.00",
      //   },
      //   {
      //     ChargeOnType: "1",
      //     ChargesType: "1",
      //     HsnSac: "",
      //     LedgerID: UserData?.LedgerID,
      //     SalePrice: "0.00",
      //     TaxPer: "0.00",
      //   },
      // ],
      OrderType: 0,
      PayableAmt: calculateSubtotal(),
      RoundOffAmt: calculateSubtotal(),
      SaleTeamID: 0,
      SoID: 0,
      SoName: "",
      SubVchType: 4,
      TaxAmt: 0,
      TaxInclusion: 1,
      TaxType: 2,
      TcsAmt: 0,
      TcsPer: 0,
      
      TdsAmt: 0,
      TdsPercent: 0,
      TotalAmt: calculateSubtotal(),
      TotalQty: items?.length,
      TtCessAmt: 0,
      TtExtraCessAmt: 0,
      UserID: UserData?.LedgerID,
      VchDate: new Date().toISOString().split("T")[0],
      VchStatus: 1,
      VchType: 3,
      ordersL1: 1,
      toEmailID: "",
      sellerid: UserData?.SellerID,
      seller: UserData?.Seller,
    };

    const url = `${apiTest_Url}/api/WebApi/paySplitPayment_ananda`;
    console.log(body)

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (response?.hasErrors == false && response != null) {
          if (response?.response?.status == 1) {
            setLoading(false);
            localStorage.setItem("SOD-UniversalDairy", JSON.stringify(payBody));
            var url = "https://pay.easebuzz.in/pay/" + response?.response?.data;
            response?.response?.data;
            window.open(url, "_self");
          }
        } else {
          setLoading(false);
          alert(response?.errors ?? "unknown error occurs");
        }
      },
      (error: any) => {},
    );
  };

  const getDisplayPrice = (ItemID: number): number => {
    const priceItem = items?.find((p) => p.ItemID === ItemID);

    const item = ItemMasterData?.find((i) => i.ItemID === ItemID);

    const caseRate = parseFloat(priceItem?.DistributorCaseRate || "0");

    const units = parseFloat(priceItem?.ItemInCase || "0");

    if (caseRate > 0 && units > 0) {
      return caseRate / units; // 304 / 40 = 7.6
    }

    return parseFloat(item?.MRP || "0");
  };

  const getPinData = (pinCode: any) => {
    const url = `${BaseUrl}/api/dynamic/AutoFillMapperWise?tabErpID=1760&tabName=Delivery%20Addresses`;
    const body = {
      depth: 10,
      accessRight: 0,
      useRegexSearch: false,
      useAtlusSearch: false,
      userID: 1002,
      filters: "{tabErpID:1760}",
      index: 1,
      isDownload: false,
      columnName: "Pincode",
      toEmailID: "it.manager@ananda.in",
      tabErpID: 1760,
      isUpdate: false,
      dataMapper: {
        CollectionName: "FINANCECONNECT_Pincode",
        filter: `{'Pincode':${pinCode}}`,
        project:
          "{'Pincode':'$Pincode','City':'$City','CityID':'$CityID','StateID':'$StateID','State':'$State','StateCode':'$StateCode','Country':'$Country'}",
        suggestedText: "",
      },
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (
          response?.hasErrors == false &&
          response?.response?.records != null &&
          response?.response?.records.length > 0
        ) {
          const data = response?.response?.records[0];

          setCity(data?.City);
          setCityID(data?.CityID);
          setState(data?.State);
          setStateID(data?.StateID);
          setStateCode(data?.StateCode);
          setCountry(data?.Country);
        } else {
          alert("Please enter a valid pincode.");
          setCity("");
          setCityID("");
          setState("");
          setStateID("");
          setStateCode("");
          setCountry("");
        }
      },
      (error: any) => {},
    );
  };

  const handleSaveAddress = () => {
    const userData: any = getUser();
    const AddressBody = [
      {
        Email: contactName,
        Address: addressLine1,
        Pincode: pincode,
        City: city,
        CityID: cityID,
        State: state,
        StateID: stateID,
        StateCode: stateCode,
        Country: country,
        AddressType: addressType,
        ContactName: contactName,
        Phone: contactMobile,
        UserMobile: userData?.SignInMobile,
        Distributor: userData?.LedgerName,
        DistributorID: userData?.LedgerID,
        Site: `${addressLine1} Site`,
      },
    ];

    PostRecords(3406, 1, AddressBody, (response: any) => {
      if (response.hasErrors === false) {
        getAddress();
        setShowAddressForm(false);

        //  handleCloseModal();
      } else {
        alert(response.errors);
      }
    });
  };

  const handleCheckbox = (e, userData: any) => {
    debugger;
    const checked = e.target.checked;
    setSameAsBilling(checked);

    if (checked) {
      const matchingAddress = AddressData?.find(
        (address: any) => address?.Address === userData?.Address,
      );

      if (matchingAddress) {
        setSelectedAddress(matchingAddress);
      } else {
        const AddressBody = [
          {
            AddressNickName: userData?.LedgerName,
            Address: userData?.Address,
            Pincode: userData?.Pincode,
            City: userData?.City,
            CityID: userData?.CityID,
            State: userData?.State,
            StateID: userData?.StateID,
            StateCode: userData?.StateCode,
            Country: userData?.Country,
            AddressType: userData?.AddressType || "",
            ContactName: userData?.LedgerName,
            ContactMobile: userData?.SignInMobile,
            UserMobile: userData?.SignInMobile,
            Distributor: userData?.LedgerName,
            DistributorID: userData?.LedgerID,
            Site: `${userData?.Address} Site`,
          },
        ];

        PostRecords(3406, 1, AddressBody, (response: any) => {
          if (response.hasErrors === false) {
            getRecords(
              3406,
              100,
              -1,
              `{SiteID: { $in: [${response?.response?.clientID}] }}`,
              1,
              "",
              (data: any) => {
                // console.log("user details response", response);

                if (data != null) {
                  if (
                    data?.hasErrors === false &&
                    data?.response?.records != null &&
                    data?.response?.records.length > 0
                  ) {
                    setSelectedAddress(data?.response?.records[0]);
                  } else {
                    // setLoading(false);
                    console.log("Error in fetching categories", data);
                  }
                } else {
                  //  setLoading(false);
                }
              },
            );

            // getAddress();
            // setShowAddressForm(false);

            //  handleCloseModal();
          } else {
            alert(response.errors);
          }
        });
      }

      // setSelectedAddress(userData);
    } else {
      setSelectedAddress(null);
    }
  };

  // const canProceedToPayment = selectedAddressId !== null || showAddressForm;

  if (items?.length === 0) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Your cart is empty
          </h1>
          <Link to="/products" className="text-amber-600 hover:underline">
            Continue Shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Checkout</h1>

          {/* <div className="flex items-center justify-center mb-12">
            <div className="flex items-center">
              <div className={`flex items-center justify-center w-10 h-10 rounded-full ${step >= 1 ? 'bg-gray-900 text-white' : 'bg-gray-200 text-gray-500'}`}>
                1
              </div>
              <div className={`w-24 h-1 ${step >= 2 ? 'bg-gray-900' : 'bg-gray-200'}`}></div>
              <div className={`flex items-center justify-center w-10 h-10 rounded-full ${step >= 2 ? 'bg-gray-900 text-white' : 'bg-gray-200 text-gray-500'}`}>
                2
              </div>
              <div className={`w-24 h-1 ${step >= 3 ? 'bg-gray-900' : 'bg-gray-200'}`}></div>
              <div className={`flex items-center justify-center w-10 h-10 rounded-full ${step >= 3 ? 'bg-gray-900 text-white' : 'bg-gray-200 text-gray-500'}`}>
                3
              </div>
            </div>
          </div> */}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              {step === 1 && (
                <div className="bg-white border border-gray-200 rounded-xl p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Billing Address
                  </h2>
                  {userData && !showAddressForm && (
                    <div className="space-y-4 mb-6">
                      <div
                        // key={address.AddressID}
                        //onClick={() => setSelectedAddress(userData)}
                        className={`relative p-5 border-2 rounded-xl cursor-pointer transition-all ${
                          true
                            ? "border-amber-500 bg-amber-50/50"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                      >
                        <div className="flex items-start gap-4">
                          <div
                            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-1 ${
                              true ? "border-amber-500" : "border-gray-300"
                            }`}
                          >
                            {true && (
                              <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                            )}
                          </div>

                          <div className="flex-1">
                            <div className="flex items-center gap-3 mb-2">
                              <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                                  true ? "bg-amber-100" : "bg-gray-100"
                                }`}
                              >
                                <i
                                  className={`${getAddressIcon("other")} ${
                                    true ? "text-amber-600" : "text-gray-500"
                                  }`}
                                ></i>
                              </div>
                              {/* <span
                                  className={`px-3 py-1 rounded-full text-xs font-medium ${
                                  true
                                      ? "bg-amber-100 text-amber-700"
                                      : "bg-gray-100 text-gray-600"
                                  }`}
                                >
                                  {userData?.AddressType}
                                </span> */}
                              {/* {address.isDefault && (
                                  <span className="text-xs text-amber-600 font-medium">
                                    Default
                                  </span>
                                )} */}
                            </div>

                            <p className="font-semibold text-gray-900">
                              {userData?.ContactName}
                            </p>
                            <p className="text-gray-600 text-sm mt-1">
                              {userData?.Address}
                            </p>
                            <p className="text-gray-600 text-sm">
                              {userData?.City}, {userData?.State} -{" "}
                              {userData?.Pincode}
                            </p>
                            <p className="text-gray-600 text-sm mt-2 flex items-center gap-4">
                              <span className="flex items-center gap-1">
                                <i className="ri-phone-line"></i>
                                {userData?.SignInMobile}
                              </span>
                              {/* <span className="flex items-center gap-1">
                                  <i className="ri-mail-line"></i>
                                  {address.email}
                                </span> */}
                            </p>
                          </div>

                          {/* {selectedAddressId === address.id && (
                              <div className="absolute top-4 right-4">
                                <i className="ri-checkbox-circle-fill text-2xl text-amber-500"></i>
                              </div>
                            )} */}
                        </div>
                      </div>
                    </div>
                  )}

                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Select Delivery Address
                  </h2>
                  <div
                    style={{ marginBottom: 10 }}
                    className="flex items-center gap-2"
                  >
                    <input
                      type="checkbox"
                      checked={sameAsBilling}
                      onChange={(e) => {
                        handleCheckbox(e, userData);
                      }}
                    />
                    <label>Delivery address same as billing</label>
                  </div>

                  {/* Saved Addresses */}
                  {AddressData?.length > 0 &&
                    !sameAsBilling &&
                    !showAddressForm && (
                      <div className="space-y-4 mb-6">
                        {AddressData?.map((address, i) => (
                          <div
                            key={address._id}
                            onClick={() => setSelectedAddress(address)}
                            className={`relative p-5 border-2 rounded-xl cursor-pointer transition-all ${
                              selectedAddress?.SiteID === address.SiteID
                                ? "border-amber-500 bg-amber-50/50"
                                : "border-gray-200 hover:border-gray-300"
                            }`}
                          >
                            <div className="flex items-start gap-4">
                              <div
                                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-1 ${
                                  selectedAddress?.SiteID === address.SiteID
                                    ? "border-amber-500"
                                    : "border-gray-300"
                                }`}
                              >
                                {selectedAddress?.SiteID === address.SiteID && (
                                  <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                                )}
                              </div>

                              <div className="flex-1">
                                <div className="flex items-center gap-3 mb-2">
                                  <div
                                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                                      selectedAddress?.SiteID === address.SiteID
                                        ? "bg-amber-100"
                                        : "bg-gray-100"
                                    }`}
                                  >
                                    <i
                                      className={`${getAddressIcon(address.SiteID)} ${
                                        selectedAddress?.SiteID ===
                                        address.SiteID
                                          ? "text-amber-600"
                                          : "text-gray-500"
                                      }`}
                                    ></i>
                                  </div>
                                  {/* <span
                                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                                      selectedAddress?.SiteID ===
                                      address.SiteID
                                        ? "bg-amber-100 text-amber-700"
                                        : "bg-gray-100 text-gray-600"
                                    }`}
                                  >
                                    {address.AddressType}
                                  </span> */}
                                  {/* {address.isDefault && (
                                  <span className="text-xs text-amber-600 font-medium">
                                    Default
                                  </span>
                                )} */}
                                </div>

                                <p className="font-semibold text-gray-900">
                                  {address?.Email}
                                </p>
                                <p className="text-gray-600 text-sm mt-1">
                                  {address.Address}
                                </p>
                                <p className="text-gray-600 text-sm">
                                  {address.City}, {address.State} -{" "}
                                  {address.Pincode}
                                </p>
                                <p className="text-gray-600 text-sm mt-2 flex items-center gap-4">
                                  <span className="flex items-center gap-1">
                                    <i className="ri-phone-line"></i>
                                    {address?.Phone}
                                  </span>
                                  {/* <span className="flex items-center gap-1">
                                  <i className="ri-mail-line"></i>
                                  {address.email}
                                </span> */}
                                </p>
                              </div>

                              {/* {selectedAddressId === address.id && (
                              <div className="absolute top-4 right-4">
                                <i className="ri-checkbox-circle-fill text-2xl text-amber-500"></i>
                              </div>
                            )} */}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                  {/* Add New Address Button */}
                  {!showAddressForm && !sameAsBilling && (
                    <button
                      onClick={() => {
                        setShowAddressForm(true);
                        setSelectedAddress(null);
                      }}
                      className="w-full p-5 border-2 border-dashed border-gray-300 rounded-xl hover:border-amber-500 hover:bg-amber-50/30 transition-all cursor-pointer flex items-center justify-center gap-3"
                    >
                      <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                        <i className="ri-add-line text-xl text-amber-600"></i>
                      </div>
                      <span className="font-medium text-gray-700">
                        Add New Address
                      </span>
                    </button>
                  )}

                  {/* New Address Form */}
                  {showAddressForm && (
                    <div className="border border-gray-200 rounded-xl p-6 bg-gray-50">
                      <div className="flex items-center justify-between mb-6">
                        <h3 className="text-lg font-semibold text-gray-900">
                          Add New Address
                        </h3>
                        {AddressData.length > 0 && (
                          <button
                            onClick={() => {
                              setShowAddressForm(false);
                            }}
                            className="text-sm text-gray-500 hover:text-gray-700 cursor-pointer"
                          >
                            Cancel
                          </button>
                        )}
                      </div>

                      {/* Address Type */}
                      <div className="mb-5">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Address Type
                        </label>
                        <div className="flex gap-3">
                          {["Home", "Office", "Shop", "Other"].map((type) => (
                            <button
                              key={type}
                              onClick={() => setAddressType(type)}
                              className={`flex items-center gap-2 px-4 py-2 rounded-lg border-2 transition-colors cursor-pointer whitespace-nowrap ${
                                addressType === type
                                  ? "border-amber-500 bg-amber-50 text-amber-700"
                                  : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"
                              }`}
                            >
                              <i className={getAddressIcon(type)}></i>
                              {type}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Full Name *
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={contactName}
                            onChange={(e) => setContactName(e.target.value)}
                            required
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                          />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {/* <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Email *
                            </label>
                            <input
                              type="email"
                              name="email"
                              value={newAddressForm.email}
                              onChange={handleNewAddressChange}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                            />
                          </div> */}

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Phone *
                            </label>
                            <input
                              type="tel"
                              name="phone"
                              value={contactMobile}
                              onChange={(e) => setContactMobile(e.target.value)}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                            />
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Address *
                          </label>
                          <textarea
                            name="address"
                            value={addressLine1}
                            onChange={(e) => setAddressLine1(e.target.value)}
                            required
                            rows={3}
                            maxLength={500}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white resize-none"
                          ></textarea>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Pincode *
                            </label>
                            <input
                              type="text"
                              name="pincode"
                              value={pincode}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, ""); // digits only
                                if (value.length <= 6) {
                                  setPincode(value);
                                }

                                if (value.length === 6) {
                                  getPinData(value);
                                }
                              }}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              City *
                            </label>
                            <input
                              type="text"
                              name="city"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              State *
                            </label>
                            <input
                              type="text"
                              name="state"
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        onClick={() => handleSaveAddress()}
                        className="w-full mt-6 py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Save & Use This Address
                      </button>
                    </div>
                  )}

                  <button
                    onClick={() => setStep(2)}
                  //  disabled={!selectedAddress}
                    className={`w-full mt-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                      true
                        ? "bg-gray-900 text-white hover:bg-gray-800 cursor-pointer"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Continue to Payment
                  </button>
                </div>
              )}

              {step === 2 && (
                <div className="bg-white border border-gray-200 rounded-xl p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Payment Method
                  </h2>

                  <div className="space-y-4">
                    <label className="flex items-center p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-amber-500 transition-colors">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="card"
                        checked={paymentMethod === "card"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="mr-4"
                      />
                      <i className="ri-bank-card-line text-2xl mr-3"></i>
                      <span className="font-medium">
                        EaseBuzz Payment Gateway
                      </span>
                    </label>

                    {/* <label className="flex items-center p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-amber-500 transition-colors">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="upi"
                        checked={paymentMethod === "upi"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="mr-4"
                      />
                      <i className="ri-smartphone-line text-2xl mr-3"></i>
                      <span className="font-medium">UPI</span>
                    </label>

                    <label className="flex items-center p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-amber-500 transition-colors">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="netbanking"
                        checked={paymentMethod === "netbanking"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="mr-4"
                      />
                      <i className="ri-bank-line text-2xl mr-3"></i>
                      <span className="font-medium">Net Banking</span>
                    </label>

                    <label className="flex items-center p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-amber-500 transition-colors">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="cod"
                        checked={paymentMethod === "cod"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="mr-4"
                      />
                      <i className="ri-money-rupee-circle-line text-2xl mr-3"></i>
                      <span className="font-medium">Cash on Delivery</span>
                    </label> */}
                  </div>

                  <div className="flex gap-4 mt-8">
                    <button
                      onClick={() => {
                        setStep(1);
                        // navigate("/");
                      }}
                      className="flex-1 py-4 bg-gray-200 text-gray-900 rounded-lg font-semibold hover:bg-gray-300 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Previous
                    </button>
                    <button
                      onClick={() => {
                         //  handlePayNow();
                        handlePayment();
                      }}
                      className="flex-1 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Pay Now
                    </button>
                  </div>

                  <div className="mt-6 flex items-center justify-center gap-3 text-sm text-gray-600">
                    <i className="ri-shield-check-line text-green-600 text-xl"></i>
                    <span>
                      Your payment information is secure and encrypted
                    </span>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div className="bg-white border border-gray-200 rounded-xl p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Review Your Order
                  </h2>

                  <div className="mb-6">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-semibold text-gray-900">
                        Shipping Address
                      </h3>
                      <button
                        onClick={() => setStep(1)}
                        className="text-sm text-amber-600 hover:text-amber-700 cursor-pointer"
                      >
                        Change
                      </button>
                    </div>
                    {selectedAddress && (
                      <div className="bg-gray-50 rounded-lg p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded-full font-medium">
                            {selectedAddress.type}
                          </span>
                        </div>
                        <p className="font-medium text-gray-900">
                          {selectedAddress.name}
                        </p>
                        <p className="text-gray-600 text-sm mt-1">
                          {selectedAddress.address}
                        </p>
                        <p className="text-gray-600 text-sm">
                          {selectedAddress.city}, {selectedAddress.state} -{" "}
                          {selectedAddress.pincode}
                        </p>
                        <p className="text-gray-600 text-sm mt-2">
                          Phone: {selectedAddress.phone} | Email:{" "}
                          {selectedAddress.email}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="mb-6">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-semibold text-gray-900">
                        Payment Method
                      </h3>
                      <button
                        onClick={() => setStep(2)}
                        className="text-sm text-amber-600 hover:text-amber-700 cursor-pointer"
                      >
                        Change
                      </button>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <p className="text-gray-600 capitalize">
                        {paymentMethod.replace("-", " ")}
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4 mt-8">
                    <button
                      onClick={() => setStep(2)}
                      className="flex-1 py-4 bg-gray-200 text-gray-900 rounded-lg font-semibold hover:bg-gray-300 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Back
                    </button>
                    <button
                      onClick={handlePlaceOrder}
                      className="flex-1 py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Place Order
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="lg:col-span-1">
              <div className="bg-gray-50 rounded-xl p-6 sticky top-24">
                <h2 className="text-xl font-bold text-gray-900 mb-6">
                  Order Summary
                </h2>

                <div className="space-y-4 mb-6">
                  {items?.map((product) => (
                    <div key={product.ItemID} className="flex gap-3">
                      <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
                        <img
                            src={
                              ItemMasterData?.find(
                                (item) => item.ItemID === product.ItemID,
                              )?.ItemPic ||
                              "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                            }
                          alt={product.Item}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-gray-900">
                          {product.Item}
                        </h4>

                        {(() => {
                          const priceItem = items?.find(
                                (p) => p.ItemID === product.ItemID,
                              );

                              const item = ItemMasterData?.find(
                                (i) => i.ItemID === product.ItemID,
                              );

                              const caseRate = parseFloat(
                                priceItem?.DistributorCaseRate || "0",
                              );
                              const units = parseFloat(
                                priceItem?.ItemInCase || "0",
                              );

                              let unitPrice = 0;
                              let unitMrp = 0;

                              if (caseRate > 0 && units > 0) {
                                unitPrice = caseRate / units; // 304 / 40 = 7.6
                                unitMrp =
                                  parseFloat(priceItem?.CaseMRP || "0") / units; // 400 / 40 = 10
                              } else {
                                unitPrice = parseFloat(item?.MRP || "0");
                                unitMrp = parseFloat(item?.MRP || "0");
                              }

                          return (
                            <>
                              <p className="text-xs text-gray-600">
                                Qty: ₹{unitPrice} {"x"}{" "}
                                {getItemQty(product?.ItemID)}
                              </p>

                              <p className="text-sm font-bold text-gray-900">
                                ₹
                                {(
                                  unitPrice * getItemQty(product?.ItemID)
                                ).toFixed(2)}
                              </p>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-300 pt-4 space-y-3">
                  <div className="flex justify-between text-gray-600">
                    <span>Subtotal</span>
                    <span className="font-semibold">
                      ₹{calculateSubtotal().toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-600">
                    <span>Shipping</span>
                    <span className="font-semibold">{"FREE"}</span>
                  </div>
                  <div className="flex justify-between text-xl font-bold text-gray-900 pt-3 border-t border-gray-300">
                    <span>Total</span>
                    <span>₹{calculateSubtotal().toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </div>
  );
}
